import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from "@angular/router";
import { GlobalCurrentUserService } from "./global-current-user.service";
import { SharedService } from './shared.service';
import { NetworkService } from 'src/app/configuration/network.service';
import { SpecialService } from 'src/app/configuration/special.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: "root"
})
export class ForceChangeUnauthGuardService implements CanActivate {
  currentUser: any;
  confiObj: any;
  KEY_VAR: any;
  IV_VAR: any;
  userData: any;
  /*
  if authenticated
	if auth expiry
		try refresh token api
         if success update localstorage hence show dashboard
		 else /login
    else /dashboard
then else /login
  */
  constructor(
    private router: Router,
    private globalCurrentUserService: GlobalCurrentUserService,
    private specialService: SpecialService,
    private sharedService:SharedService,
    private networkService:NetworkService
  ) {  }
   async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    //this.currentUser = JSON.parse(localStorage.getItem("currentUser"));

    this.sharedService.checkForceChangePassword().subscribe(result=>this.userData =result);

    this.sharedService.getConfig().subscribe(result => this.confiObj = result);
    if(!this.confiObj){
      await this.networkService.getDecryptedPassword(environment.KEYS_FILE_NAME, environment.CONFIG_FILE_NAME);
    }else if(!this.confiObj["username"] ||
    !this.confiObj["MODULE_ID"] ||
    !this.confiObj["RESET_PASS_CALLBACK_LINK"] ||
    !this.confiObj["basicApiHost"] || 
    !this.confiObj["apiHost"] ||
    !this.confiObj["loginUrl"] ||
    !this.confiObj["MODULE_NAME"])
    {
     await this.networkService.getDecryptedPassword(environment.KEYS_FILE_NAME, environment.CONFIG_FILE_NAME);
    
    }

    const url:any = state.url.split('?');
    if(url[0]==='/force-change-password'){
      if (this.userData) {
        return true;
      }else{
        this.router.navigate(["/login"]);
      }
      

  }else{
    this.globalCurrentUserService.checkLoggedIn.next(true);
    return false;
  }     
   
   }

}
